import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useContext, useEffect, useState } from "react";
import TujuanSelectorDialog from "../../dialogs/selectors/TujuanSelectorDialog";
import KaryawanSelectorDialog from "../../dialogs/selectors/KaryawanSelectorDialog";
import KendaraanSelectorDialog from "../../dialogs/selectors/KendaraanSelectorDialog";
import {
  genElDate,
  genElNumber,
  genElObject,
  genElText,
  genElTime,
} from "../../components/utils/EditorDialogElementGenerator";
import { Divider } from "primereact/divider";
import { format, set } from "date-fns";
import useIsMobile from "../../hooks/useIsMobile";


const JadwalMobilEditor = (props) => {
  const isMobile = useIsMobile();
  const {
    visible,
    onHide,
    onConfirm,
    onDelete,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  // dialog state
  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);
  const [showSupirSelector, setShowSupirSelector] = useState(false);
  const [showPemakaiSelector, setShowPemakaiSelector] = useState(false);
  const [showTujuanSelector, setShowTujuanSelector] = useState(false);

  useEffect(() => {
    if (props.visible) {
      if (data.tanggal_perkiraan_berangkat) {
        setData({
          ...data,
          tanggal_perkiraan_berangkat_jam: new Date(
            data.tanggal_perkiraan_berangkat
          ),
        });
      }
    }
  }, [props.visible]);

  /**
   * VALIDATE THE FORM DATA.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;

    // console.log("Data", data);
    let newError = {};

    const tanggal_perkiraan_berangkat = data.tanggal_perkiraan_berangkat;
    if (!tanggal_perkiraan_berangkat) {
      newError = {
        ...newError,
        tanggal_perkiraan_berangkat: "Tanggal harus diisi",
      };
      valid = false;
    }

    if (!data.data_kendaraan || data.kendaraan_id <= 0) {
      newError["data_kendaraan"] = "Kendaraan harus diisi";
      valid = false;
    }

    if (!data.data_supir || data.supir_id <= 0) {
      newError["data_supir"] = "Supir harus diisi";
      valid = false;
    }

    if (!data.data_tujuan || data.tujuan_id <= 0) {
      newError["data_tujuan"] = "Tujuan harus diisi";
      valid = false;
    }

    if (!data.data_pemakai || data.pemakai_id <= 0) {
      newError["data_pemakai"] = "Pemakai harus diisi";
      valid = false;
    }

    // if (!valid)
    setError(newError);

    return valid;
  };

  const refineData = (data) => {
    const _data = data;

    if (_data.tanggal_perkiraan_berangkat_jam) {
      const _tanggal_perkiraan_berangkat = new Date(
        _data.tanggal_perkiraan_berangkat
      );
      _tanggal_perkiraan_berangkat.setHours(
        _data.tanggal_perkiraan_berangkat_jam.getHours()
      );
      _tanggal_perkiraan_berangkat.setMinutes(
        _data.tanggal_perkiraan_berangkat_jam.getMinutes()
      );
      _tanggal_perkiraan_berangkat.setSeconds(0);
      _tanggal_perkiraan_berangkat.setMilliseconds(0);

      _data.tanggal_perkiraan_berangkat = format(
        _tanggal_perkiraan_berangkat,
        "yyyy-MM-dd HH:mm:ss"
      );

      // delete _data.tanggal_perkiraan_berangkat_jam;
    }

    if (_data.id !== undefined && _data.id <= 0) {
      delete _data.id;
    }

    return _data;
  };

  // UI Event Handler

  const handleOnClickKendaraan = () => {
    setShowKendaraanSelector(true);
  };

  const handleOnConfirmKendaraan = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_kendaraan: selected,
        kendaraan_id: selected.id,
      });
      setShowKendaraanSelector(false);
    }
    return selected;
  };

  const handleOnClickSupir = () => {
    setShowSupirSelector(true);
  };

  const handleOnConfirmSupir = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_supir: selected,
        supir_id: selected.id,
      });
      setShowSupirSelector(false);
    }
    return selected;
  };

  const handleOnClickPemakai = () => {
    setShowPemakaiSelector(true);
  };

  const handleOnConfirmPemakai = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_pemakai: selected,
        pemakai_id: selected.id,
      });
      setShowPemakaiSelector(false);
    }
    return selected;
  };

  const handleOnClickTujuan = () => {
    setShowTujuanSelector(true);
  };

  const handleOnConfirmTujuan = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_tujuan: selected,
        tujuan_id: selected.id,
      });
      setShowTujuanSelector(false);
    }
    return selected;
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elKendaraan = genElObject({
    field: "data_kendaraan",
    name: "Kendaraan",
    value: data.data_kendaraan ? data.data_kendaraan.nomor_polisi : "",
    onClick: handleOnClickKendaraan,
    error,
  });

  const elSupir = genElObject({
    field: "data_supir",
    name: "Supir",
    value: data.data_supir ? data.data_supir.nama : "",
    onClick: handleOnClickSupir,
    error,
  });

  const elPemakai = genElObject({
    field: "data_pemakai",
    name: "Pemakai",
    value: data.data_pemakai ? data.data_pemakai.nama : "",
    onClick: handleOnClickPemakai,
    error,
  });

  const elTujuan = genElObject({
    field: "data_tujuan",
    name: "Tujuan",
    value: data.data_tujuan ? data.data_tujuan.nama : "",
    onClick: handleOnClickTujuan,
    error,
  });

  const elTanggalPerkiraanBerangkat = genElDate({
    field: "tanggal_perkiraan_berangkat",
    name: "Tanggal",
    primeFormat: "dd MM yy ",
    data,
    setData,
    error,
  });

  const elTanggalPerkiraanBerangkatJam = genElTime({
    field: "tanggal_perkiraan_berangkat_jam",
    name: "Jam",
    data,
    setData,
    width: "w-[6.5rem]",
    error,
  });

  const elJumlahOrang = genElNumber({
    field: "jumlah_orang",
    name: "Jumlah Orang",
    data,
    setData,
    error,
  });

  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <div className="row-between-center w-100 pt-2">
      <Button
        className="w-[8rem] md:w-[12rem]"
        label={isMobile ? "Hapus" : "Hapus Jadwal"}
        loading={loading}
        severity="danger"
        icon="pi pi-exclamation-triangle"
        onClick={(e) => onDelete(data)}
      />
      <div className="row-end-center w-100">
        <Button
          // className="w-full"
          label="Close"
          loading={loading}
          icon="pi pi-arrow-left"
          onClick={(e) => {
            e.preventDefault();
            props.onHide();
          }}
        />
        <Button
          // className="w-full"
          severity="success"
          loading={loading}
          label="Save"
          icon="pi pi-save"
          onClick={(e) => {
            const valid = validate();
            if (valid) {
              const _data = refineData(data);
              onConfirm(_data);
            }
          }}
        />
      </div>
    </div>
  );

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[24rem] md:w-[47rem] min-h-[31rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <KendaraanSelectorDialog
        title={"Pilih Kendaraan"}
        visible={showKendaraanSelector}
        additionalFilter="data_kendaraan_jenis.nama:!=:Trado"
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />

      <KaryawanSelectorDialog
        title="Pilih Supir"
        visible={showSupirSelector}
        onHide={() => setShowSupirSelector(false)}
        onConfirm={handleOnConfirmSupir}
      />

      <KaryawanSelectorDialog
        title="Pilih Pemakai"
        visible={showPemakaiSelector}
        onHide={() => setShowPemakaiSelector(false)}
        onConfirm={handleOnConfirmPemakai}
      />

      <TujuanSelectorDialog
        title="Pilih Tujuan"
        visible={showTujuanSelector}
        onHide={() => setShowTujuanSelector(false)}
        onConfirm={handleOnConfirmTujuan}
      />

      <div className="col-start-start justify-start items-start w-full gap-4 pb-4 bg-white ">
        <div className="flex flex-col md:flex-row justify-start items-start gap-2 w-full">
          <div className="col-start-start gap-3 w-full md:w-auto">
            <div className="row-start-start gap-2  w-full md:w-auto">
              <div className="flex-grow md:flex-grow-0 md:w-[13.5rem]">
                {elTanggalPerkiraanBerangkat}
              </div>
              {elTanggalPerkiraanBerangkatJam}
            </div>
            {elKendaraan}
            {elSupir}
          </div>
          <Divider layout="vertical" className="hidden md:flex h-[13.5rem]" />
          <div className="col-start-start gap-3 w-full md:w-auto">
            {elTujuan}
            {elPemakai}
            {elJumlahOrang}
          </div>
        </div>
        {elKeterangan}
      </div>
    </Dialog>
  );
};
export default JadwalMobilEditor;
